// src/pages/Settings/ChangePassword.jsx
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { toast } from 'react-toastify';

const ChangePassword = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.oldPassword || !formData.newPassword || !formData.confirmPassword) {
      toast.error('All fields are required');
      return;
    }
    
    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }
    
    if (formData.newPassword.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    
    setLoading(true);
    try {
      await api.post('/admin/change-password', {
        userId: user.id,
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword
      });
      
      toast.success('Password changed successfully! Please login again.');
      
      // Clear form
      setFormData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
      
      // Logout after password change
      setTimeout(() => {
        logout();
      }, 2000);
      
    } catch (error) {
      toast.error(error.response?.data?.error || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bet-history-page">
      <div className="container-fluid">
        <div className="page-hedding-header">
          <h1 className="page-heading h3 text-uppercase fs-4">Change Password</h1>
        </div>
        <div className="admin-card-one">
          <div className="admin-card-header">
            <h2 className="admin-card-heading">Change Password</h2>
          </div>
          <div className="admin-card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-12">
                  <label className="admin-label-one">Old Password</label>
                  <input
                    type="password"
                    name="oldPassword"
                    value={formData.oldPassword}
                    onChange={handleChange}
                    className="form-control admin-input-one"
                    placeholder="Old Password"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="admin-label-one">New Password</label>
                  <input
                    type="password"
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    className="form-control admin-input-one"
                    placeholder="New Password"
                    required
                  />
                </div>
                <div className="col-12 mb-3">
                  <label className="admin-label-one">Confirm Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="form-control admin-input-one"
                    placeholder="Confirm Password"
                    required
                  />
                </div>
                <div className="col-12">
                  <button type="submit" className="admin-submit-one w-100" disabled={loading}>
                    {loading ? 'Saving...' : 'Save Password'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;